import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FreshDeskService } from 'app/shared-services/services/freshdesk.service';
import { UnsubscribeComponent } from 'app/shared-components/components/unsubscribe/unsubscribe.abstract';

@Component({
    templateUrl: 'loginfreshdesk.component.html',
    styleUrls: ['./loginfreshdesk.component.scss'],
    standalone: false
})

export class LoginFreshDeskComponent extends UnsubscribeComponent implements OnInit {

    constructor(
        private freshDeskService: FreshDeskService
    ) {
        super();
    }

    ngOnInit(): void {
        this.freshDeskService.getFreshDeskSSOUrl()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((response) => {
                window.open(response.supportCenterUrl, '_self');
            });
    }
}
